import merge from 'deepmerge';

const deepMerge = (target, source, arrayMerge = false) => {
  const combineMerge = (target, source, options) => {
    const destination = target.slice();
  
    source.forEach((item, index) => {
      if (typeof destination[index] === 'undefined') {
        destination[index] = options.cloneUnlessOtherwiseSpecified(item, options);
      } else if (options.isMergeableObject(item)) {
        destination[index] = merge(target[index], item, options);
      } else if (target.indexOf(item) === -1) {
        destination.push(item);
      }
    })
    return destination;
  }
  return arrayMerge ? 
    merge(target, source, { arrayMerge: combineMerge }):
    merge(target, source);
}

export default deepMerge;